import React from 'react';

import { FormModal } from 'modules';
import * as WriteRequestEditor from './WriteRequestEditor';
import * as dataService from './dataService';



export interface IProps {
  writeRequestId: string;

  onClose: () => void;
  onSaveWriteRequest: () => void;
}

export const FC: React.FC<IProps> = props => {
  const queryTuple = dataService.useQuery(props.writeRequestId);
  return (
    <FormModal.FC
      isDoubleWide
      onClose={props.onClose}
      title="Edit Write Request">
      <WriteRequestEditor.FC
        key={queryTuple.data.formattedRequestData}
        type={queryTuple.data.requestType}
        writeRequestId={props.writeRequestId}
        writeRequestContent={queryTuple.data.formattedRequestData}
        validationErrors={queryTuple.data.validationErrors}
        onShouldRefetch={props.onSaveWriteRequest} />
    </FormModal.FC>
  );
};

